export const tableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: 'Nº',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        if (item) {
                            return item.value;
                        } else {
                            return "";
                        }
                    }
                },
                {
                    title: 'Campo de inspección/alcance',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        if (item) {
                            return item.value;
                        } else {
                            return "";
                        }
                    }
                },
                {
                    title: 'Elemento a inspeccionar',
                    type: 'custom-html',
                    key: 'level_4_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            if (element.scope_master)
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de inspección o metodología',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            if (element.scope_master)
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de Organismo en base a la independencia (A,B,C)',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        if (item) {
                            return item.value;
                        } else {
                            return "";
                        }
                    }
                },
                {
                    title: 'Procedimientos de Inspección',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: 'Código tipo de la norma o especificación técnica/Vigencia de la norma o especificación técnica (Año de publicación, reafirmación, edición/revisión (cuando aplique))',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (value) => {
                        return value;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}